<template>
    <div class="equities_vip" v-for="(item, index) in EquitiesData" :key="index">
        <div class="equities_vip_div">
            <div class="equities_vip_title">{{ item.title }}</div>
            <el-divider class="heng"><i class="el-icon-mobile-phone" :class="heng"></i></el-divider>
            <div class="equities_vip_cont" v-for="(items, indexs) in item.cont" :key="indexs + '_item'"
                :class="items.isEffectivity ? 'Effectivity_text' : 'Not_Effectivity_text'">{{ items.title }}</div>
        </div>
        <el-divider direction="vertical" v-show="!item.isOver" class="shu"></el-divider>
    </div>
</template>

<script>
export default {
    name: 'CardEquitiesShow',
    props: {
        EquitiesData: {
            type: Array,
            default: () => []  // [{"title": "VIP", "cont": [{"title": "延长图片有效期", "isEffectivity": true}], "isOver": true}]
        },

    },
    data() {
        return {

        };
    },
    watch: {

    },
    methods: {
        
    },
    mounted() {
        
    },
}
</script>

<style scoped>
.equities_vip {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: center;
    align-items: center;
    padding: 10px;
}

.equities_vip_title {
    font-weight: 600;
    color: rgb(248, 217, 15);
}

.equities_vip_cont {
    font-weight: 400;
    color: rgb(0, 0, 0);
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: space-evenly;
    align-items: center;
    /* height: 100%; */
}

.Effectivity_text {
    color: rgb(0, 198, 145)
}

.Not_Effectivity_text {
    color: rgba(208, 208, 208, 0.8)
}

.equities_vip_div {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: space-evenly;
    align-items: center;
    height: 200px;
}

.heng {
    margin: 15px 0;
}

.shu {
    left: 20px;
    height: 5em;
}
</style>
